/**
 * @desc: - 选择投注mode
 * @param  {[ARRAY]}  modes:        [所有可选的投注mode]
 * @param  {[STRING]} value:        [当前选中值]
 * @param  {[FUNCTION]} onChange:   [点击变更值]
 * @author: ammo
 */
export default class SelectModes extends React.Component {

  constructor(props) {
    super(props);
    this.mode = [
      {modeid: 1, name: "元", rate: 1},
      {modeid: 2, name: "角", rate: 0.1},
      {modeid: 3, name: "分", rate: 0.01},
      {modeid: 4, name: "厘", rate: 0.001}
    ]
  }

  render() {
    const { value, onChange, ismmc } = this.props;
    return (
      <div className={ismmc ? 'select-modes' : 'select-modes expectMMc'}>
          {
            this.mode.map((item, index) =>
              <span
                key={index}
                className={value == item.rate ? 'active' : ''}
                onClick={onChange.bind(this, item)} >
                {item.name}
              </span>
            )
          }
      </div>
    );
  }
}
